import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User exited full screen mode',
  name: 'exited_full_screen',
  params: [
    {
      description: 'The context where full screen was exited',
      name: 'location',
      required: false,
      type: 'enum',
      values: ['pdf', 'video'],
    },
  ],
};

export default META;
